<template>
  <div>
    <a-form :form="form">
      <a-row :gutter="16">
        <a-col :span="24">
          <a-form-item label="Bailout Transaction">
            <a-select
              showSearch
              v-decorator="[
                'id_bailout',
                {
                  rules: [{ required: true }],
                  initialValue: initialData.id_bailout
                },
              ]"
              optionFilterProp="children"
              :filterOption="filterOption"
              class="bt_select"
              :disabled="collectData.usage && collectData.usage.length>0"
            >
              <a-select-option v-for="item in listBailout" :key="item.id_bailout">
                <div class="m-display-flex space-between m-width-full">
                  <span>{{ item.no_transaksi + " | " + item.deskripsi }}</span>
                  <span>{{ formatCurrency('IDR',item.bailout_value) }}</span>
                </div>
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Report Date">
            <a-date-picker
              placeholder="Select Date"
              disabled
              :format="getDefaultDateFormat"
              v-decorator="[
                'tanggal_pelaporan',
                {
                  rules: [{ required: true }],
                  initialValue: initialData.tanggal_pelaporan,
                },
              ]"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default{
  name: "informasi",
  mixins: [CurrencyFormat],
  props: ["id", "type", "mode", "bailoutTransmodeEdit", "collectData"],
  data() {
    return {
      listBailout: [],
    }
  },
  created(){
    this.form = this.$form.createForm(this);
  },
  mounted(){
    this.initialListBailout()
  },
  watch:{
    bailoutTransmodeEdit(){
      this.initialListBailout()
    },
    mode(){
      if(this.mode!='Edit')
        this.fetchBailoutTrans()
    }
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getDateTimeFormat",
      "getStandartFormatDate",
    ]),
    initialData() {
      if(this.id || this.collectData.information){
        return {
          id_bailout: this.collectData.information.id_bailout,
          tanggal_pelaporan: moment(this.collectData.information.tanggal_pelaporan)
        }
      }else{
        return {
          id_bailout: null,
          tanggal_pelaporan: moment()
        }
      }
    },
  },
  methods:{
    moment,
    initialListBailout(){
      if(this.id || this.type=='draft'){
        this.listBailout = this.bailoutTransmodeEdit
      }
    },
    handleRef(){
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        Event.$emit("stepsBailoutReportForm", values);
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    fetchBailoutTrans(){
      const bailoutls = axios({
        method: "get",
        url: this.$serviceUrl + "bailout_report/bailout",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        if (err.response.status === 404) {
          if (this.type != "draft") {
            this.displayMessageValue(
              "error-other",
              "No active Bailout, make sure you have an active Bailout!"
            );
            this.$router.go(-1);
          }
        }
      });

      axios
        .all([
          bailoutls.catch((err) => {
            return null;
          }),
        ])
        .then((response) => {
          if(response[0])
            this.listBailout = response[0].data.no_trans
        })
    }
  }
}
</script>
<style lang="less">
.bt_select{
  .ant-select-selection-selected-value{
    width: 100%;
  }
}
</style>